import { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';

const scrollToContact = () => {
  document.getElementById('connect')?.scrollIntoView({ behavior: 'smooth' });
};

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Navbar expand="lg" className={scrolled ? 'scrolled' : ''}>
      <Container>
        <Navbar.Toggle className="ms-auto" aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {[
              ['home', 'Home'],
              ['skills', 'Skills'],
              ['projects', 'Projects'],
            ].map(([id, label]) => (
              <Nav.Link
                key={id}
                href={`#${id}`}
                className={activeLink === id ? 'active navbar-link' : 'navbar-link'}
                onClick={() => setActiveLink(id)}
              >
                {label}
              </Nav.Link>
            ))}
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://www.linkedin.com/company/assimilation-software" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <img src={navIcon1} alt="" />
              </a>
              <a href="https://www.facebook.com/AssimilationSoftware" target="_blank" rel="noreferrer" aria-label="Facebook">
                <img src={navIcon2} alt="" />
              </a>
              <a href="https://www.instagram.com/assimilation_software/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <img src={navIcon3} alt="" />
              </a>
            </div>
            <button className="vvd" type="button" onClick={scrollToContact}>
              <span>Let&apos;s Connect</span>
            </button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
